import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Grid, Row, Cell } from '../Grid/Grid.js';
import '../Logo/wrapped-logos/LogoHsbcGlobal.js';
import LogoHsbcHexagon from '../Logo/wrapped-logos/LogoHsbcHexagon.js';
import '../Logo/wrapped-logos/LogoHsbcUk.js';
import '../Logo/wrapped-logos/LogoHsbcAmanah.js';
import '../Logo/wrapped-logos/LogoMsGlobal.js';
import '../Logo/wrapped-logos/LogoHsbcJade.js';
import '../Logo/wrapped-logos/LogoHsbcExpat.js';
import pageStyles from '../Page/page.css.js';
import Spinner from '../Spinner/Spinner.js';
import Modal from 'react-aria-modal';
import { Transition } from 'react-transition-group';
import setFocus from '../../utils/setFocus.js';
import styles from './loading.css.js';

var Loading = /*#__PURE__*/function (_Component) {
  _inherits(Loading, _Component);

  function Loading() {
    _classCallCheck(this, Loading);

    return _possibleConstructorReturn(this, _getPrototypeOf(Loading).apply(this, arguments));
  }

  _createClass(Loading, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.show === false && prevProps.show === true) {
        this.focusTimeout = setTimeout(function () {
          setFocus();
        }, 250);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.focusTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          getApplicationNode = _this$props.getApplicationNode,
          logoSlot = _this$props.logoSlot,
          children = _this$props.children,
          textMap = _this$props.textMap,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["show", "getApplicationNode", "logoSlot", "children", "textMap", "id"]);

      return React.createElement(Transition, {
        in: show,
        timeout: {
          enter: 20,
          exit: 200
        },
        mountOnEnter: true,
        unmountOnExit: true
      }, function (state) {
        return React.createElement(Modal, _extends({
          id: id,
          titleText: textMap.title,
          titleId: textMap.title ? null : "".concat(id || 'loading', "-content"),
          focusDialog: true,
          includeDefaultStyles: false,
          dialogClass: cn(styles.dialog, styles.fade, _defineProperty({}, styles['fade--entered'], state === 'entered')),
          underlayClass: cn(styles.underlay, styles.fade, _defineProperty({}, styles['fade--entered'], state === 'entered')),
          getApplicationNode: getApplicationNode,
          underlayClickExits: false,
          escapeExits: false,
          scrollDisabled: false,
          "aria-live": "assertive",
          "aria-relevant": "text",
          "aria-atomic": true
        }, rest), React.createElement(Grid, null, React.createElement(Row, null, React.createElement(Cell, {
          size: 12,
          sizeMedium: 8,
          sizeLarge: 6,
          offsetMedium: 2,
          offsetLarge: 3
        }, React.createElement("div", {
          className: styles.dialogContent
        }, React.createElement("div", {
          className: styles.logo,
          "aria-hidden": true
        }, logoSlot || React.createElement(LogoHsbcHexagon, null)), React.createElement("div", {
          className: styles.children,
          id: "".concat(id || 'loading', "-content")
        }, children), React.createElement("div", {
          className: styles.icon,
          "aria-hidden": true
        }, React.createElement(Spinner, null)))))));
      });
    }
  }]);

  return Loading;
}(Component);

_defineProperty(Loading, "defaultProps", {
  getApplicationNode: function getApplicationNode() {
    return document.querySelector(".".concat(pageStyles.Page));
  },
  textMap: {
    title: null
  }
});

Loading.propTypes = process.env.NODE_ENV !== "production" ? {
  show: PropTypes.bool.isRequired,
  getApplicationNode: PropTypes.func,
  logoSlot: PropTypes.node,
  children: PropTypes.node,
  id: PropTypes.string,
  textMap: PropTypes.shape({
    title: PropTypes.string
  })
} : {};
export default Loading;
export { Loading };